module.exports = __webpack_public_path__ + "media/notice.51a07ae7.wav";